import { isSubscriptionApplicable } from './subscriptionPolicy';

/**
 * Membership Network product constraints (minimized nav, no CRM/Vault pages,
 * verification before publish, listing AI off, etc.).
 *
 * Who gets it:
 * - productLine === 'membership' (set at /signup register), or
 * - membershipGrade set (v5 Membership path before productLine existed), or
 * - subscriptionPlan === 'Membership' without an enterprise parent
 *
 * Internal administrators never receive these constraints, including when
 * their accounts retain historical membership metadata.
 *
 * Who does NOT (they still get the Figma home via isAgencyOrAgentRole /
 * isPartnerRole — look is shared, feature cuts are not):
 * - Curated Business Solutions / enterprise-linked accounts
 * - Legacy orgs (Tyson, Remax, etc.) on Premium/Custom without membership fields
 */
export function isMembershipExperience(user) {
  if (!user || typeof user !== 'object') return false;
  if (!isSubscriptionApplicable(user)) return false;
  const line = String(user.productLine || '').toLowerCase();
  if (line === 'curated') return false;
  if (line === 'membership') return true;
  if (user.membershipGrade) return true;
  const plan = String(user.subscriptionPlan || '').toLowerCase();
  if (plan === 'membership' && !user.enterpriseId && !user.parentEnterpriseId) return true;
  return false;
}

export function isAgencyOrAgentRole(user) {
  const role = String(user?.role || '').toLowerCase();
  return role === 'agency'
    || role === 'independent_agent'
    || role === 'agent'
    || role === 'agency_agent';
}

export function isPartnerRole(user) {
  const role = String(user?.role || '').toLowerCase();
  return role === 'partner' || role === 'partner_agent';
}

export function isMembershipAgencyOrAgent(user) {
  return isMembershipExperience(user) && isAgencyOrAgentRole(user);
}

/** Membership Network industry experts (signup `who=partner`). */
export function isMembershipPartner(user) {
  return isMembershipExperience(user) && isPartnerRole(user);
}

/** Home after blocking CRM / Vault for Membership Network accounts. */
export function membershipAppHomePath(user) {
  const r = String(user?.role || '').toLowerCase();
  if (['agent', 'independent_agent', 'agency_agent'].includes(r)) return '/agent-dashboard';
  if (r === 'enterprise') return '/enterprise-dashboard';
  if (r === 'partner' || r === 'partner_agent') return '/partner-dashboard';
  return '/dashboard';
}

export const OPEN_ADD_LEAD_EVENT = 'ipm:open-add-lead';
export const LEAD_ADDED_EVENT = 'ipm:lead-added';
export const EXPERT_MODAL_EVENT = 'ipm:expert-open-modal';
